"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param el HTMLElement
 * @returns calculated properties of ClientRect
 */
var getClientRect = function (el) {
    var left = 0;
    var top = 0;
    var width = el.offsetWidth;
    var height = el.offsetHeight;
    // no layout thrash
    do {
        left += el.offsetLeft;
        top += el.offsetTop;
        el = el.offsetParent;
    } while (el);
    // TODO check this
    return { left: left, top: top, width: width, height: height, right: left + width, bottom: top + height };
};
exports.default = getClientRect;
//# sourceMappingURL=get-client-rect-from-el.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@giphy/js-util/dist/get-client-rect-from-el.js
// module id = 896
// module chunks = 0